<section class="entitylist">
  <div class="mdc-layout-grid no-offset-x">
    <div class="mdc-layout-grid__inner">
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
        <h2 class="mat-headline-2" i18n="@@featureEventDetails-pageEntityList-headline">
          Weitere Events @if (exhibitor?.display_name || exhibitor?.name) { von
          {{ exhibitor?.display_name ?? exhibitor?.name }}

          }
        </h2>
        <hr />
        <bau365-event-card-list
          [events]="eventList"
          [exhibitor]="exhibitor"
          [size]="size$ | async"
          [cardSliderConfig]="cardSliderConfig$ | async"
          context="event-details"
          [moreRouterLink]="['/fairs', exhibitor?.fair_id, 'search']"
          [moreQueryParams]="{
            searchTypes: 'EVENT',
            filter: stringifyFilter({ exhibitor: [exhibitor?.id ?? ''] })
          }"></bau365-event-card-list>
      </div>
    </div>
  </div>
</section>
